import { AfterViewInit, ContentChildren, Directive, ElementRef, QueryList, Renderer2, TemplateRef } from '@angular/core';

@Directive({
  selector: '[layerControlActions]',
  standalone:true
})
export class LayerControlActionsDirective {




  constructor(public templateRef: TemplateRef<any>, private el: ElementRef, private renderer: Renderer2) {}





}
